import type { FunctionComponent } from 'react';
import { useIsQualityEnabled } from '../../../helpers/features';

/**
 * Access gate which renders any children, but only if quality is enabled for the org.
 *
 * @example - Button only renders if quality is enabled:
 * <QualityRequired>
 *   <Button>Download Quality Report</Button>
 * </QualityRequired>
 */
const QualityRequired: FunctionComponent = ({ children }) => {
  const hasQuality = useIsQualityEnabled();

  if (!hasQuality) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default QualityRequired;
